<template lang="pug">
    .api-keys(v-if="k >= 0 && whk >= 0")
        // :prop="`administrators.${index}.cms.apiKeys.${k}.public`"
        el-form-item(:label="$t('Client ID')")
            el-input(type="input" v-model="public" maxlength="255" show-word-limit)
        // :prop="`administrators.${index}.cms.apiKeys.${k}.private`"
        el-form-item(:label="$t('Secret Key')")
            el-input(type="input" v-model="private" maxlength="255" show-word-limit)
        el-form-item(:label="$t('Webhook ID')")
            el-input(type="input" v-model="webhookId" maxlength="255" show-word-limit)
</template>

<i18n>
{
    "de": {
        "PayPal Checkout": "PayPal Checkout",
        "Webhook ID": "Webhook ID"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { useSettingsStore, useCmsWizardStore } from '@/stores'

export default {
    name: 'PayPalKeys',
    props: {
        cms: {
            type: Object,
            required: true,
        },
        env: {
            type: String,
            default: 'production',
            validator: value => ['production', 'sandbox'].includes(value)
        },
        storeModule: {
            type: String,
            default: 'settings/form',
        },
    },
    computed: {
        isWizardMode() {
            return this.storeModule === 'cmsWizard';
        },
        key() {
            let key = 'paypal-checkout-production'
            if (this.env === 'sandbox') key = 'paypal-checkout-sandbox'
            return key
        },
        webhookKey() {
            let key = 'paypal-webhook-production'
            if (this.env === 'sandbox') key = 'paypal-webhook-sandbox'
            return key
        },
        k() {
            // get the index of cms related api key with identifier 'paypal-checkout-{env}'
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.key)
        },
        whk() {
            // get the index of cms related api key with identifier 'paypal-webhook-{env}'
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.webhookKey)
        },
        public: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.public`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'public',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
        private: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.private`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'private',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
        webhookId: {
            get() {
                return _.get(this.cms, `apiKeys.${this.whk}.public`, '')
            },
            set(value) {
                const data = {
                    index: this.whk,
                    field: 'public',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        }
    },
    mounted() {
        if (this.isWizardMode) {
            if (this.k < 0) useCmsWizardStore().addCmsApiKey(this.key);
            if (this.whk < 0) useCmsWizardStore().addCmsApiKey(this.webhookKey);
        } else {
            if (this.k < 0) useSettingsStore().addFormCmsApiKey(this.key);
            if (this.whk < 0) useSettingsStore().addFormCmsApiKey(this.webhookKey);
        }
    }
}
</script>

<style lang="sass" scoped>
</style>
